export default __webpack_public_path__ + "static/left-50698c9c69bf042036e3b006fc9334a5.png";